import React from "react"
import ReactModal from "react-modal"

/**
 * Componente base para la creación de modales.
 * @param {Object} props - Propiedades del modal.
 * @param {boolean} props.visible - Indica si el modal es visible o no.
 * @param {function} props.setVisible - Función para controlar la visibilidad del modal.
 * @param {boolean} props.backdropClose - Indica si el modal se cierra al hacer clic en el fondo.
 * @param {JSX.Element} props.children - Contenido del modal.
 * @param {string} props.windowClassName - Clases CSS  para el contenedor donde va el contenido (no confundir con el overlay).
 * @param {string} props.overlayClassName - Clases CSS para el overlay del modal.
 * @param {string} props.role - necesario para accesibilidad
 * @param {string} props.ariaLabelledBy - id del titulo de la ventana
 * @param {string} props.ariaDescribedBy - id del parrafo de la ventana
 * @returns {JSX.Element} - Elemento JSX que representa el modal.
 */
export const BaseModal = ({ visible, setVisible, overlayClassName, backdropClose, children, windowClassName, role, ariaLabelledBy, ariaDescribedBy }) => {
    return <ReactModal
        isOpen={visible}
        overlayClassName={ overlayClassName || 'base-modal-overlay'}
        className={`${windowClassName}`}
        ariaHideApp={true}
        role={role || "dialog"}
        contentLabel={ariaLabelledBy}
        aria={{
            labelledby: ariaLabelledBy,
            describedby: ariaDescribedBy
        }}
        shouldFocusAfterRender={true}
        shouldReturnFocusAfterClose={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={backdropClose}
        preventScroll={true}

        onRequestClose={() => backdropClose === true && setVisible && setVisible(false)} >
        {children}
    </ReactModal>
}